import { Link, useLocation } from "react-router-dom";
import { useAccount, useBalance, useEnsName, useGasPrice } from "wagmi";
import getENV from "./util/getENV";
import useMerkle from './hooks/useMerkle';
import SearchBox from "./SearchBox";
import defined from "./util/defined";
import { ethers } from "ethers";
import { useState } from "react";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import ConnectButton from "./ConnectButton";
import equiv from "./util/equiv";
import useSkelephunks from "./hooks/useSkelephunks";
import useSkeleKeys from "./hooks/useSkeleKeys";
import useCatacombs from "./hooks/useCatacombs";
import useObituary from "./hooks/useObituary";
import useSkeleDrop from "./hooks/useSkeleDrop";
import { mainnet } from "viem/chains";

export default function Header({ subtitle }) {
    const { override, testnet, wagmi: { config: wagmiConfig }, modules, promo: { drop: dropPromo } } = getENV();
    const account = useAccount();
    let isConnected, wallet
    if (override) {
        isConnected = true;
        wallet = override
    } else {
        isConnected = account.isConnected;
        wallet = account.address;
    }
    const { status, contract: skelephunks } = useSkelephunks();
    const { drop } = useSkeleDrop();
    const { keys } = useSkeleKeys()
    const { catacombs } = useCatacombs();
    const { obituary } = useObituary();
    const gasPrice = useGasPrice()?.data;
    const { data: balanceData, status: balanceStatus } = useBalance({ config: wagmiConfig, address: wallet });
    const walletBalance = defined(balanceData) ? Number(balanceData?.formatted).toPrecision(4) : "";
    const { data: ensData, status: ensStatus, error: ensError } = useEnsName({ config: { ...wagmiConfig, chains: [...wagmiConfig.chains, mainnet] }, address: wallet, chainId: mainnet.id });
    const profileTag = obituary.getName(wallet);
    const hasProfile = obituary.hasIdentity(wallet);
    const profileToken = hasProfile ? obituary.getToken(wallet) : null;
    const tokenURI = profileToken ? catacombs.getMetadata(profileToken).image : '';
    const displayName = hasProfile ? profileTag : ensData?.split('.eth')[0] || null;
    const numMinted = skelephunks.numMinted(wallet);
    const numTokens = skelephunks.balanceOf(wallet);
    const numLocked = catacombs.balanceOf(wallet);
    const numKeys = keys.balanceOf(wallet);
    const mintStatus = skelephunks.mintStatus();
    const { drops: { proof } } = useMerkle(wallet);
    const numDrops = drop.claimableDropsForWallet(wallet, proof);
    const route = useLocation().pathname;
    const maxMinted = defined(numMinted, mintStatus) && mintStatus < 4 && numMinted > 12;
    const hasInventory = numTokens + numLocked + numKeys > 0;
    const returnVisitor = hasInventory || numMinted > 0;

    // const mintPhases = ['pre', 'claim', 'list', 'pub', 'zoo', 'post'];
    const minted = defined(numMinted) && numMinted > 0;
    const { open } = useWeb3Modal();
    const ensureConnection = () => {
        if (!isConnected) open();
    }
    const [navShown, setNavShown] = useState();
    const toggleNav = () => {
        setNavShown(!navShown);
    }
    return (<>
        <div className="title">
            <div className="blurb welcome">
                <div onClick={toggleNav} className={`shownav navcontrol`}>
                    <div className="text-block-15">{navShown ? 'HIDE' : 'SHOW'} NAVIGATION</div>
                </div>
                <div className="id-lockup">
                    {hasProfile &&
                        <Link to="/profile">
                            <div className="avatar">
                                <img src={tokenURI} />
                            </div>
                        </Link>
                    }
                    <div className="salutation" >
                        <div>welcome {returnVisitor ? 'back ' : ''}</div>
                        <div>{displayName ? <span className="identity">{displayName}</span> : 'Anon'} </div>
                    </div>
                </div>
                <div className={navShown ? '' : 'hide-small'}>
                    {route !== '/mint' &&
                        <div>
                            <Link onClick={ensureConnection} className={`yours ${navShown ? '' : 'navlink'}`} to="/mint">🔥 Mint Skelephunks</Link>
                        </div>
                    }
                    {route !== '/inventory' && isConnected && hasInventory &&//preload Tokens
                        <div>
                            <Link onClick={() => skelephunks.tokensOfOwner(wallet)} className={`yours ${navShown ? '' : 'navlink '}`} to="/inventory">💀 your collection</Link>
                        </div>
                    }
                    {route !== '/graveyard' &&
                        <div>
                            <Link className={`yours ${navShown ? '' : 'navlink'}`} to="/graveyard">🪦 Visit Graveyard</Link>
                        </div>
                    }
                    {route !== '/drop' && (!isConnected || defined(numDrops)) && (numDrops > 0 || defined(dropPromo)) &&
                        <div>
                            <Link className={`free navlink`} to="/drop">💧 {defined(dropPromo) && (!isConnected || (defined(numDrops) && numDrops == 0)) ? <>{dropPromo.nav}</> : <>You Have {numDrops > 1 ? numDrops : 'a'} drop{numDrops > 1 ? 's' : ''}</>}</Link>
                        </div>
                    }
                    <div className={`yours ${navShown ? '' : 'navlink'}`}>
                        {route != '/drop' && <SearchBox hidden={false} />}
                    </div>
                </div>
            </div>
            <div className="banner">
                <Link className="" to="/">
                    <img
                        src="/images/SKELEPHUNKS_lockup.png"
                        loading="lazy"
                        alt="Skelephunks"
                        className="image"
                        data-w-id="31a62934-7dee-bf92-5793-1bf374967db9"
                    />
                </Link>

                <h3 className="mint-title" data-w-id="b93b5472-5113-27f5-b1ae-1a2a5a5a52c2">
                    {subtitle}
                </h3>
            </div>
            <div className="blurb wallet">
                {isConnected && <>
                    <div className="address">
                        {wallet.substring(0, 13)}
                    </div>
                    {maxMinted ?
                        <div className="yours">Max Minted</div> : <div className="yours">{walletBalance} {equiv(testnet, 'goerli') ? 'g' : ''}{balanceData?.symbol}</div>
                    }
                </>}
                {defined(gasPrice) && <div className="info eth">
                    Gas is {ethers.utils.formatUnits(gasPrice?.toString(), "gwei").substring(0, 4)}  GWEI
                </div>}
                <div className="wc-button">
                    <ConnectButton />
                </div>
                <div className="iconnav">
                    <a href="https://discord.gg/YS7FgPudTr" target="_blank">
                        <img src="images/28-283551_discord-icon-png.png" loading="lazy" alt="" className="social" />
                    </a>
                    <a href="https://opensea.io/collection/skelephunks-official" target="_blank">
                        <img src="images/OS.png" loading="lazy" alt="" className="social" />
                    </a>
                    <a href="https://twitter.com/skelephunks" target="_blank">
                        <img src="images/2021-Twitter-logo---white.png" loading="lazy" alt="" className="social" data-ix="new-interaction" />
                    </a>
                </div>
            </div>
        </div>
    </>)
}